import connectController from './connect.controller';
import stConnectCall from './connectCall.component';
import stConnectCenter from './connectCenter.component';
import stConnectMinimized from './connectMinimized.component';
import stConnectSms from './connectSms.component';
import stPhoneAssign from './phoneAssign.component';
import stPhoneRent from './phoneRent.component';
import stPhonesList from './phonesList.component';

angular
  .module('st.Integrations.Connect', ['st.Call', 'st.Core', 'ngAudio'])
  .controller('connectController', connectController)
  .component('stConnectCall', stConnectCall)
  .component('stConnectCenter', stConnectCenter)
  .component('stConnectMinimized', stConnectMinimized)
  .component('stConnectSms', stConnectSms)
  .component('stPhoneAssign', stPhoneAssign)
  .component('stPhoneRent', stPhoneRent)
  .component('stPhonesList', stPhonesList)
  .constant('CONNECT', {
    API: {},
    CACHE: {
      STORE: {
        NAME: 'connectCache',
        TTL: 60 * 1000,
        DELETION: 'aggressive',
        RECYCLE: 30 * 1000,
        STORAGE: 'sessionStorage'
      }
    }
  });
